module.exports = __webpack_public_path__ + "img/logo-sustainableAmerica.59675552.png";